import { Button, Grid, TextField, Typography } from "@mui/material";
import { Box } from "@mui/system";
import * as React from "react";
import "./style/GeneralDetailUpdate.css";
import "./style/GeneralDetailUpdate.css";
import { callApi } from "../../common/api";
import CustomizedSnackbars from "../alert/alert";

export default function BankDetail() {
  const [inputData, setInputData] = React.useState({
    bankName: "",
    ifscNumber: "",
    accNumber: "",
    branch: "",
  });

  const [isData, setIsData] = React.useState(true);
  const [snackBarMsg, setSnackBarMsg] = React.useState({
    message: "",
    severity: "success",
    open: false,
  });


  async function handleInputChange(e) {
    const name = e.target.name;
    const value = e.target.value;

    if (e.target.hasAttribute('data-numeric')) {
      if (/^[0-9]*$/.test(value) || value === '') {
        setInputData((prevState) => ({
          ...prevState,
          [name]: value,
        }));
      } else {
        setSnackBarMsg({
          message: "Please enter valid Bank Account number.",
          severity: "warning",
          open: true,
        });
      }
    } else {
      if (name == "bankName") {
        if (value !== "" && !/^[A-Za-z\s]+$/.test(value)) {
          setSnackBarMsg({
            message: "Please Enter valid Bank Name.",
            severity: "error",
            open: true,
          });
          return
        } else {

          setInputData((prevState) => ({
            ...prevState,
            [name]: value
          }));
        }
      }
      if (name == "branch") {
        if (value !== "" && !/^[A-Za-z\s]+$/.test(value)) {
          setSnackBarMsg({
            message: "Please Enter valid Branch Name.",
            severity: "error",
            open: true,
          });
          return
        }
        else {

          setInputData((prevState) => ({
            ...prevState,
            [name]: value
          }));
        }
      }
      else {
        setInputData((prevState) => ({
          ...prevState,
          [name]: value
        }));
      }

    }
  }

  async function handleUpdate(e) {
    e.preventDefault();
    const data = { ...inputData };
    const isAnyFieldEmpty = Object.values(inputData).some(value => value === "" || value === null);
    if (isAnyFieldEmpty) {
      setSnackBarMsg({
        message: "Please fill all required fields.",
        severity: "error",
        open: true,
      });
      return;
    } else if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(inputData.ifscNumber)) {
      setSnackBarMsg({
        message: "Please enter valid IFSC code.",
        severity: "error",
        open: true,
      });
      return
    } else if (!/^[0-9]{8,20}$/.test(inputData.accNumber)) {
      setSnackBarMsg({
        message: "Please enter valid Bank Account number.",
        severity: "error",
        open: true,
      });
      return
    } else if (!/^[A-Za-z\s]+$/.test(inputData.bankName)) {
      setSnackBarMsg({
        message: "Please enter valid Bank name.",
        severity: "error",
        open: true,
      });
      return
    } else if (!/^[A-Za-z]+$/.test(inputData.branch)) {
      setSnackBarMsg({
        message: "Please enter valid Branch name.",
        severity: "error",
        open: true,
      });
      return
    }
    try {
      const response = await callApi(
        "post",
        "bankDetail/BankInfo",
        data,
        { "content-type": "application/json" },
        true,
        false
      );
      
      if (response.data.response.status) {
        setSnackBarMsg({
          message: "Details Edit Successfully",
          severity: "success",
          open: true,
        });
        setIsData(true);
      } else {
        setSnackBarMsg({
          message: "Some error occur",
          severity: "error",
          open: true,
        });
      }
    } catch {
      setSnackBarMsg({
        message: "Some error occur",
        severity: "error",
        open: true,
      });
    }
  }
  async function HandleEdit() {
    setIsData(false);
  }
  async function handleGet() {
    try {
      const response = await callApi("get", "bankDetail/getBankData ");
      let newData = response?.data?.data;
      if (Object.keys(newData).length > 0) {
        setInputData(newData);
        setSnackBarMsg({
          message: "Data Get Successfully",
          severity: "success",
          open: true,
        });
      }
    } catch (err) {
      console.log(err)
    }
  }
  React.useEffect(() => {
    handleGet();
  }, []);
  return (
    <>
      <h2 className="marginTop">Bank Detail</h2>

      {isData ? (
        <div className="general-detail-box investorformpage">
          <div className="row">
            <div className="col-md-4 col-12">
              <div className="ltdetail">
                <p>Bank Name</p>
              </div>
            </div>
            <div className="col-8">
              <div className="rtdetail">
                <p> {inputData.bankName || "--"}</p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4 col-12">
              <div className="ltdetail">
                <p>IFSC Number</p>
              </div>
            </div>
            <div className="col-8">
              <div className="rtdetail">
                <p>{inputData.ifscNumber || "--"}</p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4 col-12">
              <div className="ltdetail">
                <p>Account Number</p>
              </div>
            </div>
            <div className="col-8">
              <div className="rtdetail">
                <p>{inputData.accNumber || "--"}</p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4 col-12">
              <div className="ltdetail">
                <p>Branch</p>
              </div>
            </div>
            <div className="col-8">
              <div className="rtdetail">
                <p>{inputData.branch || "--"}</p>
              </div>
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-12">
              <a style={{ cursor: "pointer", fontWeight: "500" }} className="commanbutton commanbuttonprofile d-block text-center" onClick={HandleEdit}>Edit</a>
            </div>
          </div>
        </div>
      ) : (
        <>
          <div class="general-detail-box investorformpage ">

            <div class="investorform">
              <form>
                <div class="row">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-12 text-white">
                    <div class="mb-3">
                      <label class="form-label text-white-50">Bank Name<span>*</span></label>
                      <input type="text" class="form-control" name="bankName"
                        value={inputData.bankName}
                        onChange={handleInputChange} placeholder="Enter name" />
                    </div>
                  </div>
                  <div class="col-lg-12 col-md-12 col-sm-12 col-12 text-white">
                    <div class="mb-3">
                      <label class="form-label text-white-50">IFSC Code<span>*</span></label>
                      <input type="text" class="form-control" name="ifscNumber"
                        value={inputData.ifscNumber}
                        onChange={handleInputChange} placeholder="Enter IFSC Code" />
                    </div>
                  </div>
                  <div class="col-lg-12 col-md-12 col-sm-12 col-12 text-white">
                    <div class="mb-3">
                      <label class="form-label text-white-50">Account Number<span>*</span></label>
                      <input data-numeric type="text" class="form-control" name="accNumber"
                        value={inputData.accNumber}
                        onChange={handleInputChange} placeholder="Enter Account Number" />
                    </div>
                  </div>

                  <div class="col-lg-12 col-md-12 col-sm-12 col-12 text-white">
                    <div class="mb-3">
                      <label class="form-label text-white-50">Branch<span>*</span></label>
                      <input type="text" class="form-control" name="branch"
                        value={inputData.branch}
                        onChange={handleInputChange} placeholder="Enter Branch" />
                    </div>
                  </div>


                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-12 mt-4">
                  <button type="submit" class="btn d-block w-100 btn-primary" onClick={handleUpdate}>Update</button>
                </div>
              </form>
            </div>



          </div>

        </>
      )}



      <CustomizedSnackbars msgData={snackBarMsg} setMsgData={setSnackBarMsg} />
    </>
  );
}
